/**
 * User Live-Location Marker & Broadcast Constants
 *
 * Visual + timing constants for the always-on local user dot and the
 * live location-sharing broadcast. No colors here — the dot is themed via CSS vars.
 *
 * @module constants/userLocation
 */

/** Diameter of the solid center dot in pixels. */
export const USER_LOCATION_DOT_SIZE_PX = 14;

/** Diameter of the surrounding accuracy/presence halo in pixels (at rest). */
export const USER_LOCATION_HALO_SIZE_PX = 28;

/** Peak scale factor the halo expands to during one pulse cycle. */
export const USER_LOCATION_HALO_PULSE_SCALE = 2.4;

/** Duration of one halo pulse cycle in seconds (CSS animation). */
export const USER_LOCATION_PULSE_DURATION_S = 2;

/** Halo opacity at the start of a pulse (most visible). */
export const USER_LOCATION_PULSE_OPACITY_MAX = 0.45;

/** Halo opacity at the end of a pulse (faded out). */
export const USER_LOCATION_PULSE_OPACITY_MIN = 0;

/** Angular width of the heading direction cone in degrees. */
export const USER_LOCATION_HEADING_CONE_ANGLE_DEG = 60;

/** Minimum interval between outgoing position broadcasts in milliseconds. */
export const USER_LOCATION_BROADCAST_THROTTLE_MS = 5000;

/**
 * Keepalive base interval in milliseconds, mirroring the backend location TTL
 * (~60s). This is NOT a client-side stale-drop TTL — no such drop exists. Its
 * sole consumer derives the keepalive cadence as `USER_LOCATION_TTL_MS / 2`,
 * guaranteeing at least one refresh before a stationary user's entry expires
 * server-side.
 */
export const USER_LOCATION_TTL_MS = 60000;
